export default function SearchResultFactory(Log, moment) {
    var factory = this;

    factory.housesInline = [];

    factory.periodsWithinSelectedTime = {
        status: false,
    };

    /**
     *
     * IF user has selected a specific global time frame (from - to hour)
     */
    factory.anyPeriodsWithinSelectedTime = (ParentLanes, searchFilter) => {
        ParentLanes[0].Lanes.forEach((lane) => {
            lane.Prices.forEach((period) => {
                period._display = factory.isPeriodWithinSelectedTime(
                    period,
                    searchFilter
                );
            });

            const periodsToDisplay = lane.Prices.filter(
                (period) => period._display
            );

            lane._display = periodsToDisplay.length ? true : false;
        });

        const parentsToDisplay = ParentLanes[0].Lanes.filter(
            (lane) => lane._display
        );

        ParentLanes[0]._display = parentsToDisplay.length ? true : false;

        factory.periodsWithinSelectedTime.status = ParentLanes[0]._display;
    };

    factory.isPeriodWithinSelectedTime = function (period, searchFilter) {
        /**
         * check search filter
         */

        const start = moment(
            searchFilter.startDate + " " + searchFilter.startTime + ":00",
            "DD-MM-YYYY HH:mm"
        );

        const end = moment(
            searchFilter.startDate + " " + searchFilter.endTime + ":00",
            "DD-MM-YYYY HH:mm"
        );

        if (moment(period.BookingStart) >= start) {
            if (searchFilter.endTime == -1) {
                // -1 rest of day (including dates after)
                return true;
            }

            if (moment(period.BookingEnd) <= end) {
                return true;
            }

            return false;
        }

        return false;
    };

    factory.findHouseInline = function (lookUpID) {
        let houseInfo = null;

        angular.forEach(factory.getHousesInline(), function (item) {
            if (item.ID == lookUpID) {
                houseInfo = item;
            }
        });
        return houseInfo;
    };

    factory.setHousesInline = function (items) {
        factory.housesInline = items;
    };

    factory.getHousesInline = function () {
        if (factory.housesInline) {
            // Log.obj("INLINE", factory.housesInline);
            return factory.housesInline;
        } else {
            Log.string("No Houses Found");
        }
    };

    return factory;
}
